export default {
  cooperativaContato: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/contacts/external/components/search/search-form.js